const initialState = {
    viewerRef: null,
};
// Attach clear life-cycle to sceneSlice reducer.
// const clearActionType = clear.type;
const setViewerRefActionType = 'appRefs/setViewerRef';
export const appRefsReducer = (state = initialState, action) => {
    switch (action.type) {
        // case clearActionType: {
        //   return { viewerRef: undefined };
        // }
        case setViewerRefActionType: {
            const viewerRef = action.payload;
            return Object.assign(Object.assign({}, state), { viewerRef });
        }
        default:
            return state;
    }
};
export const setViewerRef = (payload) => {
    return { type: setViewerRefActionType, payload };
};
